const BANKS_WITH_NO_ACCOUNT_NUMBER = ["Apple", "Stripe", "Paypal"] as const;

export function isBankWithoutAccountNumber(bankName: string) {
    return BANKS_WITH_NO_ACCOUNT_NUMBER.some((bank) =>
        bankName.toLowerCase().includes(bank.toLowerCase()),
    );
}
